import { Component, inject, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PipesModule } from '@digipay/ng-lib-pipes';

import { CALCULATOR_ROUTE } from '../../../../data-access/constants/app-routes';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-calculated-info-card',
  templateUrl: './calculated-info-card.component.html',
  styleUrls: ['./calculated-info-card.component.scss'],
  standalone: true,
  imports: [PipesModule, DecimalPipe],
})
export class CalculatedInfoCardComponent {
  @Input() fromDate!: string;
  @Input() toDate!: string;
  @Input() amount!: string;
  navigationService = inject(WealthNavigationService);

  constructor(private route: ActivatedRoute) {}

  onRecalculate() {
    this.navigationService.navigateWithQueryParams([CALCULATOR_ROUTE], {
      queryParams: this.route.snapshot.queryParams,
    });
  }
}
